import TiersInformations from "./TiersInformations.jsx";

export default TiersInformations;
